<template>
  <section class="loginReg" :style="{'--panelColor': panelColor}">
    <div class="loginReg-header-container">
      <img :src="accessConfig.headerLogo" alt>
    </div>
    <div class="loginReg-container">
      <img class="loginReg-background-img" :src="accessConfig.newPasswordView.bg" alt>
      <div class="loginReg-first-container" v-if="accessConfig.newPasswordView.position=='right'">
        <transition appear name="translate">
        <div class="loginReg-eventLogo" v-html="accessConfig.newPasswordView.eventLogo"></div>      
        </transition>
      </div>
      <div class="loginReg-second-container">
        <div class="register-title" v-html="accessConfig.newPasswordView.newPasswordContainer"></div>
        <div class="inputs-wrapper">
          <div :class="{'password-input-wrapper':!shakePassword, 'input-wrapper shakeAnimation':shakePassword}">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="password-input" type="password" :placeholder="accessConfig.newPasswordView.passwordPlaceholder" @keypress="checkLogin" v-model="password">
          </div>
          <div :class="{'password-input-wrapper':!shakePassword, 'input-wrapper shakeAnimation':shakePassword}">
            <ion-icon class="ionicon-icon" name="lock-closed-outline"></ion-icon>
            <input class="password-input" type="password"  id="password" :placeholder="accessConfig.newPasswordView.confirmPasswordPlaceholder" @keypress="checkLogin" v-model="confirmPassword">
          </div>
          <button class="enter-and-send-btn" @click.prevent="savePassword"><p v-html="accessConfig.newPasswordView.buttonText"></p></button>
          <div class="bottom-instructions">
            <a class="login-forgot-password" href="#/" ><p v-html="accessConfig.newPasswordView.backButtonText"></p></a>            
          </div>
        </div>
      </div>
    </div>  
  <Footer />
  </section>
</template>

<script>
import api from '@/services/api';
import encrypt from '@/services/encrypt';
import Footer from '@/components/general/Footer.vue';

export default {
  name: 'NewPassword',
  components: { Footer },

  data() {
    return {
      password: '',
      confirmPassword: '',
      token: '',
      shakePassword: false,
      accessConfig: {},
      panelColor: 'transparent',
    };
  },

  methods: {
    checkLogin(key) {
      if (key.keyCode == 13) this.savePassword();
    },

    async savePassword() {
      if (this.password == this.confirmPassword) {
        api
          .post(`event/${this.$store.state.eventId}/createNewPassword`, {
            password: await encrypt(this.password.trim()),
            token: this.$route.params.token,
          })
          .then((response) => {
            //console.log(response);
            this.$router
              .push({
                name: 'Login',
              })
              .catch((err) => {
                console.log('navigation error', err);
              });
          })
          .catch((err, data) => {
            console.log('error', err.response, data);
            this.$modal.show('dialog', {
              title: '',
              text: this.accessConfig.newPasswordView.failMessage,
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    this.$modal.hide('dialog');
                  },
                },
              ],
            });
          });
      } else {
        this.$modal.show('dialog', {
          title: '',
          text: this.accessConfig.newPasswordView.mismatchMessage ? this.accessConfig.newPasswordView.mismatchMessage : 'Password mismatch',
          buttons: [
            {
              title: 'Ok',
              handler: () => {
                this.$modal.hide('dialog');
              },
            },
          ],
        });
        // alert(this.accessConfig.newPasswordView.mismatchMessage ? this.accessConfig.newPasswordView.mismatchMessage : 'Password mismatch');
        this.shakePassword = true;
        setTimeout(() => {
          this.shakePassword = false;
        }, 500);
      }
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    if (this.accessConfig.loginView.panelColor) this.panelColor = this.accessConfig.loginView.panelColor;
  },
};
</script>


<style lang="scss">
</style>